<template>
  <div id="app">
    <layout-auth v-if="path && path === '/login'" />
    <layout-main v-if="path && path !== '/login'" />
  </div>
</template>

<script>
import LayoutMain from '@/layouts/LayoutMain'
import LayoutAuth from '@/layouts/LayoutAuth'

export default {
  name: 'App',
  components: {
    LayoutMain,
    LayoutAuth
  },
  data () {
    return {
      path: null
    }
  },
  watch: {
    $route (to) {
      this.path = to.path
    }
  },
  created () {
    this.path = document.location.pathname
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/main';

body {
  height: 100%;
  #app {
    height: 100%;
  }
}
</style>
